Ext.define('SA.data.Vendors', {
    singleton: true,

    getDatasetModel(series) {
        return this.getDatasetModels().find(dataset => dataset.getId() === series);
    },

    getDatasetModels() {
        return [...SA.data.UserDatasets.getModels(), ...this.nonImportDatasets];
    },

    forCountry(countryCode) {
        return SA.Array.unique(
            this.nonImportDatasets.filter(dataset => {
                return dataset.hasCountryCode(countryCode);
            }).map(dataset => {
                return dataset.getVendorName();
            })
        );
    },

    getACSModel() {
        return this.getDatasetModels().find(dataset => dataset.isACS());
    },

    getDatasetSeriesNameSorter() {
        return (itemA, itemB) => {
            var [nameA, nameB] = [itemA, itemB].map(item => item.datasetSeriesName.replace(/P\$YCLE/g, 'PSYCLE'));

            return SA.data.Sort.titleText(nameA, nameB);
        };
    },

    getImportsVendorName() {
        return 'imports'; 
    },

    getScarboroughCrosstabModel() {
        return this.getDatasetModels().find(dataset => dataset.isScarboroughCrosstab());
    },

    getSimmonsCrosstabModel(censusReleaseYear) {
        return this.getSimmonsCrosstabModels().find(dataset => dataset.hasCensusReleaseYear(censusReleaseYear)) ?? null;
    },

    getSimmonsCrosstabModels() {
        return this.getDatasetModels().filter(dataset => dataset.isSimmonsCrosstab());
    },

    isImportsVendorName(name) {
        return name === this.getImportsVendorName();
    },

    async loadAll({datasetFactory}) {
        var datasetSeriesMap = await SA.Ajax.request({resource: 'attributeDatasetSeries'});

        this.nonImportDatasets = Object.entries(datasetSeriesMap).flatMap(([id, {
            name,
            premium,
            latestEdition: latestEditionInLatestCensusRelease,
            editions,
            latestGeographicRelease,
            vendor: vendorName,
            hasFolders
        }]) => {
            return Object.entries(editions).map(([countryCode, editions]) => {
                return datasetFactory.create({
                    countryCode,
                    vendorName,
                    id,
                    name,
                    premium,
                    editions,
                    latestGeographicRelease,
                    latestEditionInLatestCensusRelease,
                    hasFolders
                });
            });
        });
    }
});